import SVGIconWrapper from "./SVGIconWrapper"

const IconChevronRight = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 11 35"
        iconClass={`icon--chevron-right ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M0 34l1.8 1L11 18v-1L1.8 0 0 1l9 16.5z" />
    </SVGIconWrapper>
)

export default IconChevronRight